import { EDeleteAllNotificationActionTypes, TDeleteAllNotificationsLoading } from './types';
import { actionGenerator } from '../../../utils/redux/actionGenerator';

export const deleteAllLoading: () => TDeleteAllNotificationsLoading =
  actionGenerator<EDeleteAllNotificationActionTypes.Loading>(EDeleteAllNotificationActionTypes.Loading);
